<template>
    <div id="nerd-help-sidebar" v-show="$store.state.sidebarVisible">
        <button class="close" @click.prevent="hide">&times;</button>
        <iframe :src="url" frameborder="0"></iframe>
    </div>
</template>

<script>
    import {LIGHTBOX_SET_MEDIA, LIGHTBOX_SET_VISIBLE, SIDEBAR_SET_VISBILE} from "./store/mutations";

    const URL = /localhost/.test(location.href) || /sve\.test/.test(location.href) ? 'http://localhost:8080' : 'https://sve-help.nerdlichter.com';

    export default {
        name: "Sidebar",
        computed: {
            url() {
                return `${URL}${this.$store.state.sidebarUrl}`;
            }
        },
        methods: {
            hide() {
                this.$store.commit(SIDEBAR_SET_VISBILE, false);
            }
        },

        mounted() {
            window.addEventListener('message', ev => {
                if(ev.data.action === 'lightbox') {
                    this.$store.commit(LIGHTBOX_SET_MEDIA, ev.data.media);
                    this.$store.commit(LIGHTBOX_SET_VISIBLE, true);
                }
            })
        }
    }
</script>

<style lang="scss" scoped>


    #nerd-help-sidebar {
        z-index: 100000;
        background-color: #fff;

        position: fixed;
        right: 0;
        top: 0;
        left: auto;
        bottom: 0;
        height: 100vh;

        box-shadow: 0 0 20px rgba(0,0,0,.25);

        width: 475px;

        iframe {
            z-index: 100001;

            display: block;
            width: 100%;
            height: 100%;
        }

        .close {
            position: absolute;
            z-index: 100002;

            right: 10px;
            top: 10px;

            background-color: transparent;
            font-size: 30px;
            line-height: 30px;

            border: 0;
        }

    }
</style>
